import React from "react";
import { FaPlane } from "react-icons/fa";

const FlightLoader = ({
  message = "Please wait...",
  subMessage = "We are looking for all available flights for you",
  IsBook = false,
}) => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/90 backdrop-blur-sm px-4">
      <div className="bg-white rounded-2xl border border-ink-100 shadow-card px-8 py-10 sm:px-12 sm:py-12 text-center max-w-sm w-full">
        <div className="relative h-16 w-16 mx-auto mb-6">
          <div className="absolute inset-0 rounded-full border-4 border-brand-100" />
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-brand-600 animate-spin" />
          <div className="absolute inset-0 flex items-center justify-center">
            <FaPlane className="text-brand-600 -rotate-45" size={18} />
          </div>
        </div>

        <div className="text-lg font-bold text-ink-900 mb-1.5">{message}</div>

        {!IsBook && (
          <p className="text-sm text-ink-500">{subMessage}</p>
        )}
      </div>
    </div>
  );
};

export default FlightLoader;
